import type { CategoryGroup } from '../api/lots';

export interface PickedCode {
  code: string;
  label: string;
}

export const MAX_CATEGORY_CODES = 20;

/** JSON keeps labels containing | intact; older shared links remain supported. */
export function readCategorySelection(codes: string, labels: string): PickedCode[] {
  let names: unknown = labels.split('|');
  if (labels.startsWith('[')) {
    try { names = JSON.parse(labels); } catch { /* Legacy label. */ }
  }
  const labelList = Array.isArray(names) ? names : [];
  const seen = new Set<string>();
  return codes.split(',').flatMap((raw, index) => {
    const code = raw.trim();
    if (!code || seen.has(code)) return [];
    seen.add(code);
    const label = labelList[index];
    return [{ code, label: typeof label === 'string' && label.trim() ? label : code }];
  });
}

export function categorySelectionParams(codes: PickedCode[]): Record<string, string | null> {
  return {
    enstru: codes.length ? codes.map((item) => item.code).join(',') : null,
    cat_label: codes.length ? JSON.stringify(codes.map((item) => item.label)) : null,
    section: null,
    cat_group: null,
  };
}

export function categoryGroup(value: string): CategoryGroup | undefined {
  return value === 'goods' || value === 'works' || value === 'services' ? value : undefined;
}
